import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Close ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_Navdraw = _resolveComponent("Navdraw")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_ContactForm = _resolveComponent("ContactForm")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_Header),
          _createVNode(_component_v_main, { class: "main bg-background" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view, null, {
                default: _withCtx(({ route, Component }) => [
                  _createVNode(_Transition, {
                    name: route.meta?.transition || 'fade'
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                    ]),
                    _: 2
                  }, 1032, ["name"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Navdraw),
          _createVNode(_component_Footer)
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: this.$store.state.popupContactForm.show,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.$store.state.popupContactForm.show) = $event)),
        fullscreen: _ctx.display.smAndDown,
        scrim: false,
        transition: "dialog-bottom-transition"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ContactForm, {
            class: "mt-md-n16",
            selectedQueryType: this.$store.state.popupContactForm.selectedQuery,
            serviceName: this.$store.state.popupContactForm.selectedService,
            title: this.$store.state.popupContactForm.title,
            isPopup: true,
            onSubmit: _cache[0] || (_cache[0] = ($event: any) => (this.$store.commit('closePopupContactForm')))
          }, null, 8, ["selectedQueryType", "serviceName", "title"])
        ]),
        _: 1
      }, 8, ["modelValue", "fullscreen"]),
      _createVNode(_component_v_snackbar, {
        modelValue: this.$store.state.snackbar.show,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.$store.state.snackbar.show) = $event))
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            color: this.$store.state.snackbar.color,
            variant: "text",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (this.$store.commit('closeSnackbar')))
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(this.$store.state.snackbar.text) + " ", 1)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}